import { useMemo } from 'react';
import { Cell, ClickableIcon, IconVerticalMenu, Menu, type MenuItem } from '@direct-frontend/components';
import { type TestProps } from '@direct-frontend/components/testing';
import { type BaseRowData } from '@adv-frontend/data-provider';
import { type ColumnCellTemplateProps } from '@adv-frontend/grid';
import { VerticalMenu } from '../../../VerticalMenu';
import { type GridRow as GridRowData } from '../../lib/types';

export interface CellSelectProps<RowData extends BaseRowData = GridRowData>
    extends ColumnCellTemplateProps<RowData>,
        TestProps {
    getItems: (data: RowData) => MenuItem[];
}

export function CellMenu<RowData extends BaseRowData = GridRowData>({
    'data-testid': dataTestId,
    getItems,
    data,
}: CellSelectProps<RowData>) {
    const items = useMemo(() => getItems(data), [data, getItems]);

    return (
        <Cell data-testid={dataTestId} align="left" size="m" type="Icon" leftPadding={false}>
            <Menu
                data-testid={`${dataTestId}.Kebab`}
                size="m"
                items={items}
                trigger={
                    <ClickableIcon data-testid={`${dataTestId}.Kebab.OpenButton`} role="supplementary">
                        <IconVerticalMenu size="20" />
                    </ClickableIcon>
                }
            />
            <VerticalMenu data-testid={dataTestId} items={items} />
        </Cell>
    );
}
